import { jsx as e } from "react/jsx-runtime";
import { s as m, j as n } from "../../../index-DVHhaa_b.js";
const i = ({ displayName: t, contactId: r, onClick: a, selected: o }) => /* @__PURE__ */ e(
  m,
  {
    itemType: "student",
    title: t,
    avatar: /* @__PURE__ */ e(n, { contactId: r, contactFullName: t }),
    selected: o,
    onClick: a
  }
);
export {
  i as StudentItem
};
//# sourceMappingURL=student.js.map
